import { Components, Theme } from "@mui/material";

export const MuiDrawer: Components<Omit<Theme, "MuiDrawer">>["MuiDrawer"] = {
  styleOverrides: {
    root: {
      width: "100%",
      height: "100%",
      maxWidth: "800px",
      display: "flex",
      flex: 1,
    },
  },
};
